export default function getUrlParam(name) {
  let result = null
  let tmp = []
  const items = location.search.substr(1).split('&')
  for (var index = 0; index < items.length; index++) {
    tmp = items[index].split('=')
    if (tmp[0] === name) result = decodeURIComponent(tmp[1])
  }
  return result
}



// WEBPACK FOOTER //
// ./src/helpers/getUrlParam.js